export const getDefaultState = () => {
    return {
        levels: [],
        level: {
            name: null,
        },
        validation_level_3: {
            name: null,
        },
        search:{
            name: null,
        }
    }
}
export default getDefaultState()
